import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledMenu = styled.section`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    transition: ${theme.transition};
    opacity: 0;
    border-bottom: 1px solid #ffffff33;

    .main-menu-mobile__items {
        display: none;
    }

    &.color {
        background: #F8F8F8;

        .sub-menu-wrapper {
            top: 70px;

            li {
                &:after {
                    display: none !important;
                }
            }
        }

        .top_header {
            opacity: 0;
            height: 0;
            visibility: hidden;
            padding: 0;
        }

        .middle_content .middle-menu li a {
            color: #152637;
        }

        .middle-menu {
            li {
                &:after {
                    background: #152637 !important;
                }
            }
        }

        .menu-hamburger {
            svg {
                circle {
                    fill: #152637;
                }
            }
        }

        .text-content {
            p {
                color: #152637 !important;
            }
        }

        .hamburger-btn {
            img {
                &:first-child {
                    display: none;
                }

                &:last-child {
                    display: block !important;
                }
            }


        }
    }

    .sub-menu-wrapper {
        position: fixed;
        left: 0;
        right: 0;
        top: 115px;
        background: white;
        padding: 60px ${props => props.offset + 15}px 40px;
        //transition: all 0.4s cubic-bezier(0.25, 0.74, 0.22, 0.99);
        //opacity: 0;
        //visibility: hidden;
        //overflow-y: scroll;
        overflow: hidden;
        max-height: calc(100vh - 120px);
        width: calc(100% - ${props => props.offset * 2 + 15}px);
        margin: 0 auto;

        .dc-btn a {
            display: inline-flex !important;
            padding: 0 !important;
        }

        .top {
            padding-bottom: 60px;
            border-bottom: 1px solid #152637;

            &.active {
                a {
                    color: #dd223f;

                    span {
                        color: #dd223f !important;
                    }
                }
            }

            ul {
                display: flex;
                gap: 30px;
                flex-wrap: wrap;

                li {
                    flex: 0 0 calc(33.3333% - 40px);

                    a {
                        font-weight: 500;
                        font-size: 1rem; /* 16px */
                        line-height: 1.25rem; /* 20px */
                        letter-spacing: 0; /* 0% = normal */
                        color: #152637;
                        display: inline-flex;
                        gap: 15px;
                        transition: ${theme.transition};
                        padding: 0;
                        align-items: center;

                        &.no-icon {
                            span {
                                font-weight: 600 !important;
                            }

                        }

                        @media (max-width: 1366px) {
                        }

                        img {
                            width: 40px;
                            height: 30px;
                        }

                        span {
                            font-weight: 500;
                            font-size: 1rem; /* 16px */
                            line-height: 1.25rem; /* 20px */
                            letter-spacing: 0; /* 0% = normal */
                            color: #152637;
                            transition: ${theme.transition};
                        }

                        &:hover {
                            span {
                                color: rgba(221, 34, 63, 1);
                            }
                        }
                    }

                    .sub-item-deep {
                        gap: 5px !important;
                        margin-top: 15px;

                        li {
                            margin: 0 !important;

                            a {
                                margin: 0;
                            }
                        }
                    }

                }


            }


        }

        .bottom {
            padding-top: 40px;

            .d-flex {
                display: flex;
                justify-content: space-between;
                align-items: center;

                h6 {
                    font-weight: 500;
                    font-size: 1rem; /* 16px */
                    line-height: 1.5rem; /* 24px */
                    letter-spacing: 0; /* 0% = normal */
                    color: #152637;

                    i {
                        color: #dd223f;
                    }
                }
            }
        }
    }

    .top_header {
        backdrop-filter: blur(20px);
        background: rgba(0, 0, 0, 0.2);
        padding: 10px 0;
        opacity: 1;
        height: auto;
        visibility: visible;
        transition: ${theme.transition};

        .col-md-5.offset-md-7 {
            display: flex;
            justify-content: flex-end;
        }

        @media (max-width: 1024px) {
            display: none;
        }

        .d-flex {
            gap: 30px;
            justify-content: flex-end;
        }

        .social {
            svg {
                margin: 0;
            }
        }

        .single-item {
            a {
                display: inline-flex;
                align-items: center;
                font-weight: 400;
                font-size: 0.8125rem; /* 13px ÷ 16 */
                line-height: 1.2rem; /* 16px ÷ 16 */
                letter-spacing: 0; /* 0% = normal spacing */
                color: white;

                svg {
                    margin-right: 5px;
                    transition: ${theme.transition};
                }

                &:hover {
                    path {
                        fill: #dd223f;
                    }
                }
            }
        }
    }

    .fix-it {
        position: absolute;
        right: 0;
        bottom: 0;
        object-fit: cover;
        left: 0;
        z-index: -1;
    }

    .middle_content {
        //padding: 25px 0;
        position: relative;

        @media (max-width: 1024px) {
            z-index: 999;
        }

        .container {
            .row {
                align-items: center;

                .hamburger-btn {
                    position: relative;
                    @media (max-width: 767px) {
                        width: 50%;
                    }
                    img {
                        width: 90px;

                        &:last-child {
                            display: none;
                        }
                    }

                    .hamburger-lines {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;

                        &:hover {
                            .line1 {
                                width: 0;
                                transition: width 0.3s ${theme.transition};
                            }

                            .line2 {
                                width: 4vw;
                                transform: translateY(-5px);
                                transition: width 0.3s ${theme.transition},
                                transform 0.3s ${theme.transition};
                            }
                        }
                    }
                }

                .button_wrapper {
                    gap: 15px;
                    @media (max-width: 767px) {
                        width: 50%;
                    }

                    .wrapper {
                        position: relative;
                        z-index: 99999;
                    }
                }
            }
        }

        .middle-menu {
            display: flex;
            gap: 30px;
            align-items: center;
            justify-content: center;

            li {
                position: relative;

                &:after {
                    position: absolute;
                    content: '';
                    width: 0;
                    bottom: 0;
                    transition: ${theme.transition};
                    left: 0;
                    height: 2px;
                    right: 0;
                    background: #ffffff;
                    opacity: 0;
                }

                &.active {
                    &:after {
                        opacity: 1;
                        width: 100%;
                    }
                }

                a {
                    font-weight: 500;
                    font-size: 1rem; /* 16px ÷ 16 */
                    line-height: 1.25rem; /* 20px ÷ 16 */
                    letter-spacing: 0; /* 0% = normal spacing */
                    color: white;
                    padding: 25px 0;
                    display: inline-block;

                    .sub-menu-wrapper {
                        a {
                            padding: 0;
                        }
                    }

                    &:hover {
                        .sub-menu-wrapper {
                            opacity: 1;
                            visibility: visible;

                            .dc-btn {
                                a {
                                    color: #152637;

                                    &:hover {
                                        color: #dd223f;
                                    }
                                }
                            }

                            a {
                                color: #dd223f;
                            }
                        }
                    }
                }

                &:hover {
                    &:after {
                        opacity: 1;
                        width: 100%;
                    }

                    .sub-menu-wrapper {
                        opacity: 1;
                        visibility: visible;

                        .dc-btn {
                            a {
                                color: #152637;

                                &:hover {
                                    color: #dd223f;
                                }
                            }
                        }

                        a {
                            color: #dd223f;
                        }
                    }
                }
            }
        }

        @media (max-width: 1024px) {
            padding: 25px 0;
            backdrop-filter: blur(20px);
            background: rgba(0, 0, 0, 0.2);
            .col-md-8 {
                display: none;
            }

            .middle-menu {
                display: none;
            }
        }
    }

    .overlay {
        background: rgb(0 0 0 / 50%);
        backdrop-filter: blur(10px);
        opacity: 0;

        @media (max-width: 1024px) {
            display: none !important;
        }
    }

    .overlay-main-bg {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgb(0 0 0 / 50%);
        backdrop-filter: blur(10px);
        z-index: 999999;
    }

    .menu-overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        background: #efefef;
        opacity: 0;
        visibility: hidden;
        z-index: 999;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100svh;
        width: 33.333%;

        @media (max-width: 1024px) {
            top: 75px;
            height: calc(100svh - 75px);
            width: 100%;
        }
		@media(max-width: 767px){
			z-index: 90;
		}
    }

    &.scroll-down {
        transform: translate3d(0, -100%, 0);
    }

    &.scroll-up {
        transform: translate3d(0, 0, 0);
    }

    .top-section {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 0;
        z-index: 3;
        padding: 0 40px !important;
        top: 100px;

        &.container {
            height: auto;
            margin: 0 auto;
            position: relative;
        }

        &:hover {
            .nav-item {
                color: rgba(255, 255, 255, 0.5);
                transition: color ${theme.transition} 0.3s;
				
            }
        }
    }

    .relative {
        border-bottom: 1px solid #15263733;
        padding-bottom: 20px;
        margin-bottom: 20px;

        .item-wrapper {
            opacity: 0;
            transform: translateY(15px);

            .accordion-item {
                background: transparent;
                border-radius: 0;
                border: none;

                .accordion-header {
                    .accordion-button {
                        background: transparent;
                        border-radius: 0;
                        border: none;
                        padding: 0;
                        font-weight: 500;
                        font-size: 1.5rem; /* 24px ÷ 16 */
                        line-height: 1.75rem; /* 28px ÷ 16 */
                        letter-spacing: 0; /* 0% = normal spacing */
                        color: #152637;
                        transition: ${theme.transition};

                        &:after {
                            background-image: url('/images/static/arrowdone.svg');
                        }

                        &[aria-expanded='true'] {
                            border-bottom: 1px solid #152637;
                            padding-bottom: 20px;
                            @media (max-width: 1366px) {
                                padding-bottom: 15px;
                            }
                        }
                    }
                }

                .accordion-body {
                    padding: 20px 0;

                    .item-single {
                        margin-bottom: 10px;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        a {
                            font-weight: 500;
                            font-size: 1rem; /* 16px */
                            line-height: 1.5rem; /* 24px */
                            letter-spacing: 0; /* 0% = normal spacing */
                            
                            &.active {
                                color: #dd223f !important;
                            }
                        }
                    }

                    @media (max-width: 1366px) {
                        padding: 15px 0;
                    }
                }
            }

            .nav-item {
                color: #152637;
                cursor: pointer;
                background: none;
                border: none;
                text-align: left;
                counter-reset: compteListe;
                list-style-type: none;
                position: relative;
                z-index: 1;
                transition: ${theme.transition};
                font-family: ${theme.fonts.heading};
                font-weight: 500;
                font-size: 1.5rem; /* 24px ÷ 16 */
                line-height: 1.75rem; /* 28px ÷ 16 */
                letter-spacing: 0; /* 0% = normal spacing */

                &:hover {
                    color: ${theme.colors.hover} !important;
                    z-index: 100 !important;
                    transition: ${theme.transition};
					@media(max-width: 767px){
                        color: #152637 !important;
					}
                }
                
                &.active {
                    color: #dd223f !important;
                    
                    svg {
                        circle {
                            stroke: #dd223f;
                        }
                        path {
                            stroke: #dd223f;
                        }
                    }
                }
            }

            &:hover {
                position: relative;
                z-index: 100;
            }
        }

        @media (max-width: 1366px) {
            padding-bottom: 15px;
            margin-bottom: 15px;
        }
    }

    .bottom-section {
        padding: 0 0 90px;
        position: absolute;
        z-index: 99;
        left: 0;
        right: 0;
        bottom: 0;

        .container {
            height: auto;
            margin: 0 auto;
            position: relative;
            padding-top: 50px;

            &:after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                width: calc(100% - 30px);
                top: 0;
                height: 1px;
                margin: 0 auto;
                background: ${theme.colors.themeColor300};
            }
        }

        .dc-btn-link {
            &:first-child {
                a {
                    text-decoration: underline;
                }
            }

            &:last-child {
                a {
                    font-weight: bold;
                }
            }
        }

        a {
            color: rgba(33, 33, 33, 0.6);
            font-size: 0.9rem;
            font-style: normal;
            font-weight: 400;
            line-height: 21.78px; /* 21.78px */
            letter-spacing: -0.396px;
        }

        .info-section {
            display: flex;
            justify-content: space-around;
        }
    }

    .mobile-menu {
        display: none;
        position: relative;
        margin: 0;
        height: calc(100vh - 125px);
        overflow-y: scroll;

        .dc-btn {
            padding-bottom: 60px;
        }

        .relative {
            .item-wrapper {
                transform: translateY(0);
                opacity: 1;

                a {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
					@media(max-width: 767px){
						img{
							height: 32px;
							width: 32px;
						}
					}
                    
                    &.active {
                        color: #dd223f !important;
                        
                        svg {
                            circle {
                                stroke: #dd223f;
                            }
                            path {
                                stroke: #dd223f;
                            }
                        }
                    }
                }
            }
        }
    }

    .sub-menu-sub {
        position: fixed;
        top: 75px;
        padding: 60px 15px;
        background: white;
        left: 0;
        right: 0;
        height: calc(100svh - 60px);
        transition: ${theme.transition};
        transform: translateX(100%);
        opacity: 0;
        visibility: hidden;
        z-index: 333;
        overflow-y: scroll;

        &.active {
            transform: translateX(0);
            opacity: 1;
            visibility: visible;
            width: 100%;
        }

        .content-menu {
            border-top: 1px solid #152637;
            border-bottom: 1px solid #152637;
            padding: 20px 0;
            margin-bottom: 60px;

            h6 {
                font-weight: 500;
                font-size: 1rem; /* 16px */
                line-height: 1.5rem; /* 24px */
                letter-spacing: 0; /* 0% */

                i {
                    color: #dd223f;
                }
            }

            .dc-btn {
                padding: 0;
            }
        }

        .back-down {
            display: flex;
            align-items: center;
            gap: 25px;
            margin-bottom: 60px;

            p {
                font-weight: 500;
                font-size: 1.5rem; /* 24px */
                line-height: 1.75rem; /* 28px */
                letter-spacing: 0; /* 0% = normal */
            }
        }

        .relative {
            .item-wrapper {
                a {
                    justify-content: unset !important;
                    gap: 15px;
                    
                    &.active {
                        color: #dd223f !important;
                    }
                }
            }
        }
    }

    @media (max-width: 1024px) {
        .col-md-2 {
            width: 50%;
            flex: 0 0 50%;
        }

        .top-section {
            padding: 0 15px !important;
            top: 60px;
            display: none;
        }

        .mobile-menu {
            display: block;
            padding: 0 15px !important;
            top: 60px;
        }
    }

    @media(max-width: 767px){
        .col-md-10{
            display: none;
        }
    }
`;
